import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["side", "stage", "className", "additionalControls", "bordered", "dateView", "isLoading", "message", "withUsername", "offset", "withBackground", "withDate", "reply", "zoneType", "wrapperProps", "author"];
import React, { forwardRef } from 'react';
import { Wrapper } from "../../../ui/Wrapper";
export var withMessageWrapper = function withMessageWrapper(_ref) {
  var bordered = _ref.bordered,
    withDate = _ref.withDate,
    withBackground = _ref.withBackground,
    dateView = _ref.dateView,
    offset = _ref.offset,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? '' : _ref$wrapperClassName;
  return function (WrappedComponent) {
    return /*#__PURE__*/forwardRef(function (_ref2, ref) {
      var _ref3;
      var _ref2$side = _ref2.side,
        side = _ref2$side === void 0 ? 'opposite' : _ref2$side,
        stage = _ref2.stage,
        _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? '' : _ref2$className,
        additionalControls = _ref2.additionalControls,
        borderedProp = _ref2.bordered,
        dateViewProp = _ref2.dateView,
        isLoading = _ref2.isLoading,
        message = _ref2.message,
        withUsername = _ref2.withUsername,
        offsetProp = _ref2.offset,
        withBackgroundProp = _ref2.withBackground,
        withDateProp = _ref2.withDate,
        reply = _ref2.reply,
        zoneType = _ref2.zoneType,
        _ref2$wrapperProps = _ref2.wrapperProps,
        wrapperProps = _ref2$wrapperProps === void 0 ? {} : _ref2$wrapperProps,
        author = _ref2.author,
        otherProps = _objectWithoutProperties(_ref2, _excluded);
      var Component = WrappedComponent;
      return /*#__PURE__*/React.createElement(Wrapper, _extends({
        additionalControls: additionalControls,
        author: author,
        bordered: (_ref3 = typeof bordered === 'function' ? bordered(side) : bordered) !== null && _ref3 !== void 0 ? _ref3 : borderedProp,
        className: [wrapperClassName, className].join(' '),
        date: message.date,
        dateView: dateView || dateViewProp,
        isLoading: isLoading,
        message: message,
        offset: offset || offsetProp,
        ref: ref,
        reply: reply,
        side: side,
        stage: stage,
        withBackground: withBackground !== null && withBackground !== void 0 ? withBackground : withBackgroundProp,
        withDate: withDate !== null && withDate !== void 0 ? withDate : withDateProp,
        withUsername: withUsername,
        zoneType: zoneType
      }, wrapperProps, {
        "data-t-id": "hocs-withMessageWrapper"
      }), /*#__PURE__*/React.createElement(Component, _extends({
        message: message,
        side: side,
        stage: stage
      }, otherProps, {
        "data-t-id": "hocs-withMessageWrapper"
      })));
    });
  };
};